<template>
	<div class="SalesForecast">
		<navbarv2 />
		<section class="s1">
			<div class="s1__container">
				<el-row>
					<el-col
						:xs="24"
						:sm="24"
						:md="10"
						:lg="10"
						:xl="10"
						class="s1__page_intro"
					>
						<h1 class="s1__page_title">
							Sales Forecasting
						</h1>
						<p>
							Accurate Sales forecast using machine learning and statistical
							tools to manage and plan your resources better. NymbleUp uses key
							parameters such as Historical Sales Data, Weather, Marketing
							Calendar, External events to provide accurate forecast for sales.
						</p>
						<h2>Sales Analytics</h2>
						<p>
							Track sales at location and item level. Get data at company,
							region and location wise to compare stores the right way.
						</p>
					</el-col>
					<el-col
						:xs="24"
						:sm="24"
						:md="14"
						:lg="14"
						:xl="14"
						class="s1_image_section"
					>
						<img
							src="../../assets/images/sales_forcast/Sales Forecasting.jpg"
							class="s1__small-image"
						/>
					</el-col>
				</el-row>
			</div>
		</section>
		<section class="s2 features-section-lead lead-section">
			<div class="s1__container">
				<h2>FEATURES</h2>
				<div class="s2__features_col">
					<el-row>
						<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
							<div class="features-section">
								<div class=" s2_feature_image">
									<img
										src="../../assets/images/FEATURES_icons/ResourcePlanning.png"
									/>
								</div>
								<div class="s2_feature_text">
									<h4>Resource Planning</h4>
									<!-- <p>Increase revenue with smart upsell features like pop-up modifiers and assist the server with visual menus</p> -->
								</div>
							</div>
						</el-col>
						<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
							<div class="features-section">
								<div class="s2_feature_image">
									<img
										src="../../assets/images/FEATURES_icons/Menu_Optimization.png"
									/>
								</div>
								<div class="s2_feature_text">
									<h4>Menu Optimisation</h4>
									<!-- <p>Increase revenue with smart upsell features like pop-up modifiers and assist the server with visual menus</p> -->
								</div>
							</div>
						</el-col>
						<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
							<div class="features-section">
								<div class="s2_feature_image">
									<img
										src="../../assets/images/FEATURES_icons/Menu_Adherence.png"
									/>
								</div>
								<div class="s2_feature_text">
									<h4>Menu Adherence</h4>
									<!-- <p>Increase revenue with smart upsell features like pop-up modifiers and assist the server with visual menus</p> -->
								</div>
							</div>
						</el-col>
						<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
							<div class="features-section">
								<div class="s2_feature_image">
									<img
										src="../../assets/images/FEATURES_icons/Expiry&waste_management.png"
									/>
								</div>
								<div class="s2_feature_text">
									<h4>Expiry and Waste Management</h4>
									<!-- <p>Increase revenue with smart upsell features like pop-up modifiers and assist the server with visual menus</p> -->
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</section>
		<RequestDemo />
		<footerbar />
	</div>
</template>
<script>
export default {
	name: "SalesForecast",
	data() {
		return {
			routes: this.$route
		};
	},
	mounted() {
		console.log(this.$route.path);
		console.log(this.routes.path);
	}
};
</script>
<style lang="scss">
@import "./SalesForecast.scss";
@import "./SalesForecastM.scss";
</style>
